import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { useGetExperiment } from '../../../../experiments/hooks'
import { EXPERIMENT_NAME_PDP_DELIVERY_OPTIONS } from '../../../../experiments/model/EXPERIMENT_NAME'
import { EXPERIMENT_VARIATION } from '../../../../experiments/model/EXPERIMENT_VARIATION'
import { nowBasicCheckResponseAccessorGetNowFirstDeliverySlotDayAndTime } from '../../../../now'
import { useProductPageContext } from '../../productPageContext'

export const ProductBuyBoxNowDeliveryOptionDeliveryMessage: FC = () => {
  const pdpDeliveryOptions = useGetExperiment(
    EXPERIMENT_NAME_PDP_DELIVERY_OPTIONS,
  )

  const { nowDetails } = useProductPageContext()

  const deliverySlotData =
    nowBasicCheckResponseAccessorGetNowFirstDeliverySlotDayAndTime(
      nowDetails.nowDataPerProductCurrentVariantResponse,
    )

  return pdpDeliveryOptions.variant === EXPERIMENT_VARIATION.V1 ||
    pdpDeliveryOptions.variant === EXPERIMENT_VARIATION.V2 ? (
    <FormattedMessage
      id="general.label.now.product.deliveryAvailable"
      values={{
        day: deliverySlotData?.deliveryDay,
        hour: deliverySlotData?.deliveryEndTime,
      }}
    />
  ) : (
    <FormattedMessage
      id="general.label.now.product.deliveryAvailableShort"
      values={{
        day: deliverySlotData?.deliveryDay,
        hour: deliverySlotData?.deliveryEndTime,
      }}
    />
  )
}
